import { jsxs as t, jsx as a } from "react/jsx-runtime";
import { Icon as o } from "../icon/icon.js";
import "react";
import { Text as l } from "../text/text.js";
import h from "clsx";
import { e as m, f, g as u, h as p } from "../../virginmediao2-momentum-icons-icons-fas-C-qJ8QLF.js";
import '../../assets/badge.css';const w = "_badge_1h3v0_1", x = "_badge__icon_1h3v0_84", e = {
  badge: w,
  "badge--info": "_badge--info_1h3v0_24",
  "badge--error": "_badge--error_1h3v0_32",
  "badge--warning": "_badge--warning_1h3v0_39",
  "badge--success": "_badge--success_1h3v0_46",
  "badge--offer": "_badge--offer_1h3v0_53",
  "badge--primary": "_badge--primary_1h3v0_61",
  "badge--outline": "_badge--outline_1h3v0_69",
  "badge--rounded": "_badge--rounded_1h3v0_80",
  badge__icon: x,
  "badge--sizer": "_badge--sizer_1h3v0_89"
}, z = (s, d) => {
  switch (s) {
    case "error":
      return /* @__PURE__ */ a(o, { icon: p, size: d, color: "inherit" });
    case "success":
      return /* @__PURE__ */ a(o, { icon: u, size: d, color: "inherit" });
    case "warning":
      return /* @__PURE__ */ a(o, { icon: f, size: d, color: "inherit" });
    default:
      return /* @__PURE__ */ a(o, { icon: m, size: d, color: "inherit" });
  }
}, T = ({
  title: s,
  outline: d,
  variant: r = "warning",
  className: c,
  showIcon: i,
  icon: g,
  iconSize: n = "md",
  rounded: b,
  ..._
}) => /* @__PURE__ */ t(
  "div",
  {
    className: h(
      {
        [e.badge]: !0,
        [e["badge--outline"]]: !!d,
        [e["badge--info"]]: r === "info",
        [e["badge--success"]]: r === "success",
        [e["badge--warning"]]: r === "warning",
        [e["badge--error"]]: r === "error",
        [e["badge--sizer"]]: !i,
        [e["badge--rounded"]]: !!b,
        [e["badge--black"]]: r === "black",
        [e["badge--offer"]]: r === "offer",
        [e["badge--countdown"]]: r === "countDown",
        [e["badge--primary"]]: r === "primary"
      },
      c
    ),
    "data-testid": "badge",
    ..._,
    children: [
      i && /* @__PURE__ */ a("div", { className: e.badge__icon, "data-testid": "badge-icon", children: g ? /* @__PURE__ */ a(o, { icon: g, size: "sm", color: "inherit" }) : z(r, n) }),
      /* @__PURE__ */ a(
        l,
        {
          className: e.badge__text,
          "data-testid": "badge-text",
          size: "T200",
          weight: "bold",
          color: "inherit",
          children: s
        }
      )
    ]
  }
);
export {
  T as Badge,
  z as getIcon
};
